var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed-item"},[_c('h1',[_vm._v(_vm._s(_vm.feed.name))]),_c('p',[_vm._v(_vm._s(_vm.feed.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }